<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="2" />
            <div class="box5">
                <div style="overflow: hidden">
                    <div class="box6" style="float: left">个人信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%">
                    <div style="overflow: hidden">
                        <div class="left_txt" style="margin-top: 30px">用户头像</div>
                        <div style="float: left; border-radius: 50%; overflow: hidden; width: 80px; height: 80px; margin-left: 20px; position: relative">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="avatar_uploader" :before-upload="beforeUpload">
                                <img v-if="obj.avatar" style="width: 80px; height: 80px; border-radius: 50%; position: absolute; top: 0; left: 0" :src="'/api/file/preview/' + obj.avatar" alt="avatar" />
                                <div v-else style="border-radius: 50%; width: 80px; height: 80px"></div>
                            </a-upload>
                        </div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">昵称<span style="color: red">*</span></div>
                        <a-input v-model="obj.nickname" placeholder="昵称" style="float: left; margin-left: 4%; width: 400px" />
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">用户类型</div>
                        <a-radio-group v-model="obj.userClass" style="float: left; margin-left: 4%; width: 400px;margin-top:4px">
                            <a-radio :value="0">
                                个人用户
                            </a-radio>
                            <a-radio :value="1">
                                企业用户
                            </a-radio>
                        </a-radio-group>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%" v-if="obj.userClass === 1">
                        <div class="left_txt">企业用户类型</div>
                        <a-radio-group v-model="obj.userClassName" style="float: left; margin-left: 4%; width: 400px;margin-top:4px">
                            <a-radio :value="'法人'">
                                法人
                            </a-radio>
                            <a-radio :value="'经办人'">
                                经办人
                            </a-radio>
                        </a-radio-group>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">性别</div>
                        <a-radio-group v-model="obj.gender" style="float: left; margin-left: 4%; width: 400px;margin-top:4px">
                            <a-radio :value="'0'">
                                未知
                            </a-radio>
                            <a-radio :value="'1'">
                                男
                            </a-radio>
                            <a-radio :value="'2'">
                                女
                            </a-radio>
                        </a-radio-group>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">手机号码</div>
                        <a-input disabled v-model="username" placeholder="手机号码" style="float: left; margin-left: 4%; width: 400px" />
                        <div class="chang_tel" style="cursor: pointer" @click="change_tel('change')">更换手机号</div>
                        <div class="chang_tel" style="cursor: pointer;color:#333333" @click="change_tel('relieve')">解除绑定</div>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">姓名<span style="color: red">*</span></div>
                        <a-input v-model="obj.name" placeholder="姓名" style="float: left; margin-left: 4%; width: 400px" />
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">{{ isSchool ? '证件号码' : '身份证号码' }}<span style="color: red">*</span></div>
                        <a-input v-model="obj.idcard" :placeholder="isSchool ? '证件号码' : '身份证号码'" style="float: left; margin-left: 4%; width: 400px" />
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">{{ isSchool ? '证件照片' : '身份证照片' }}<span style="color: red">*</span></div>
                        <div style="overflow: hidden; margin-left: 14%">
                            <div style="float: left">
                                <a-upload style="width: 170px; height: 132px" name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="idCardImage_uploader">
                                    <img v-if="obj.idCardImage" :src="'/api/file/preview/' + obj.idCardImage" style="width: 170px; height: 132px" alt="avatar" />
                                    <div v-else style="width: 170px; height: 132px">
                                        <a-icon :type="loading ? 'loading' : 'plus'" style="font-size: 60px; color: #e8e6e6; margin-top: 10px" />
                                        <div class="ant-upload-text" style="color: #999; font-size: 14px; margin-top: 10px">{{ isSchool ? '上传证件正面' : '上传身份证正面' }}</div>
                                    </div>
                                </a-upload>
                            </div>

                            <div style="float: left; overflow: hidden; margin-left: 40px">
                                <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="idCardImageReverse_uploader">
                                    <img v-if="obj.idCardImageReverse" :src="'/api/file/preview/' + obj.idCardImageReverse" style="width: 170px; height: 132px" alt="avatar" />
                                    <div v-else style="width: 170px; height: 132px">
                                        <a-icon :type="loading ? 'loading' : 'plus'" style="font-size: 60px; color: #e8e6e6; margin-top: 10px" />
                                        <div class="ant-upload-text" style="color: #999; font-size: 14px; margin-top: 10px">{{ isSchool ? '上传证件反面' : '上传身份证反面' }}</div>
                                    </div>
                                </a-upload>
                            </div>
                        </div>
                        <div class="tips" v-if="isSchool">注：请上传教师证/学生证/校园卡等证件的图片，支持jpg、jpeg、png</div>
                    </div>

                    <div style="overflow: hidden">
                        <div class="left_txt">证件有限期<span style="color: red">*</span></div>
                        <!-- <a-range-picker :defaultValue="[obj.idCardStartTime, obj.idCardEndTime]" @change="sfz_time_onChange" style="float: left; margin-left: 4%; width: 400px" /> -->
                        <a-date-picker v-model="obj.idCardStartTime" placeholder="请选择" style="float: left;width: 190px;margin-left:40px; margin-left: 35px; " />
                        <a-date-picker v-model="obj.idCardEndTime" :showToday="false" placeholder="请选择" style="float: left;width: 190px; margin-left: 20px;"></a-date-picker>
                    </div>

                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">地址<span style="color: red">*</span></div>

                        <div style="float: left; margin-left: 4%">
                            <div style="overflow: hidden">
                                <a-select style="width: 117px" :value="obj.district.district1 ? obj.district.district1 : '请选择省'" @change="sheng_Change">
                                    <a-select-option :key="index" v-for="(item, index) in all_available" :value="item.name">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                                <a-select style="width: 117px; margin-left: 20px" default-value="请选择市" :value="obj.district.district2 ? obj.district.district2 : '请选择市'" @change="shi_Change">
                                    <a-select-option :key="index" v-for="(item, index) in all_shi" :value="item.name">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                                <a-select style="width: 117px; margin-left: 20px" default-value="请选择区" :value="obj.district.district3 ? obj.district.district3 : '请选择区'" @change="qu_Change">
                                    <a-select-option :key="index" v-for="(item, index) in all_qu" :value="item.name">
                                        {{ item.name }}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </div>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div class="left_txt">详细地址<span style="color: red">*</span></div>
                        <a-input v-model="obj.district.districtDetail" placeholder="详细地址" style="float: left; margin-left: 4%; width: 400px" />
                    </div>
                    <div style="width: 100%; height: 1px; border: 1px dashed #eeeeee; margin-top: 4%"></div>
                    <div class="save_but" @click="save_user_info">保存</div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            loading: false,
            all_shi: '', // 下级市
            all_qu: '', // 下级区
            all_available: '', // 所有省份
            username: '', //手机
            obj: {
                userClass: 0,
                userClassName: '',
                avatar: '', //头像
                corpIdCardImage: '', //法人代表身份证图片
                gender: 0, //性别: 值为1时是男性，值为2时是女性，值为0时是未知
                idCardImage: '', //身份证照片
                idCardImageReverse: '', //身份证照片反面
                idcard: '', //身份证号
                legalPerson: '', //法定代表人
                licenseImage: '', //营业执照图片
                name: '', //真实姓名
                registrationDate: '', //($date-time)主体注册日期
                subjectName: '', //主体全称
                unifiedSocialCreditCode: '', //统一信用代码
                district: {
                    district1Id: '',
                    district2Id: '',
                    district3Id: '',
                    district1: '',
                    district2: '',
                    district3: '',
                    districtDetail: ''
                },
                isSchool: false //判断是否为大专院校
            }
        };
    },
    methods: {
        // 接触/修改 绑定手机号
        change_tel(type) {
            this.$router.push({
                name: 'change_tel',
                params: {
                    type: type
                }
            });
        },
        onChangeClassUser() {},
        // 获取地址资源
        get_all_available() {
            this.api.get_all_available().then(res => {
                this.all_available = res.data;
                this.sheng_Change(this.obj.district.district1);
                this.shi_Change(this.obj.district.district2);
            });
        },
        // 切换地址
        sheng_Change(e) {
            this.obj.district.district1 = e;
            this.obj.province = e;
            this.all_available.forEach(element => {
                if (element.name == e) {
                    this.obj.district.district1Id = element.id;
                    this.all_shi = element.children;
                }
            });
        },
        shi_Change(e) {
            this.obj.district.district2 = e;
            this.obj.city = e;
            this.all_shi.forEach(element => {
                if (element.name == e) {
                    this.obj.district.district2Id = element.id;
                    this.all_qu = element.children;
                }
            });
            console.log(this.obj);
        },
        qu_Change(e) {
            this.obj.district.district3 = e;
            this.obj.area = e;
            console.log(this.obj.area);
            this.all_qu.forEach(element => {
                if (element.name == e) {
                    this.obj.district.district3Id = element.id;
                    this.all_qu2 = element.children;
                }
            });
        },
        // 头像
        avatar_uploader(e) {
            if (e.file.status === 'done') {
                this.obj.avatar = e.file.response.data.uuid;
            }
        },
        beforeUpload(file) {
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpgOrPng) {
                this.$message.error('你只能上传JPG文件！');
            }
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error('图像必须小于10MB!');
            }
            return isJpgOrPng && isLt2M;
        },

        // 身份证正面
        idCardImage_uploader(e) {
            if (e.file.status === 'done') {
                this.obj.idCardImage = e.file.response.data.uuid;
            }
        },

        // 身份证反面
        idCardImageReverse_uploader(e) {
            if (e.file.status === 'done') {
                this.obj.idCardImageReverse = e.file.response.data.uuid;
                console.log(this.obj.idCardImageReverse);
            }
        },

        // 身份证有效期
        sfz_time_onChange(e) {
            this.obj.idCardStartTime = e[0]._d;
            this.obj.idCardEndTime = e[1]._d;
        },

        // 获取我的信息
        get_user_info() {
            this.api.user_info().then(res => {
                this.obj = res.data;
                // debugger;
                if (res.data.company) {
                    this.isSchool = res.data.company.userType == '大专院校科研院所';
                }
                if (!this.obj.district) {
                    this.obj.district = {
                        district1: '',
                        district1Id: null,
                        district2: '',
                        district2Id: null,
                        district3: '',
                        district3Id: null,
                        districtDetail: ''
                    };
                }
                this.get_all_available();
                this.username = res.data.mobile ? res.data.mobile : '未绑定手机号';
            });
        },

        // 保存我的信息
        save_user_info() {
            if (this.obj.name == '' || this.obj.nickname == '' || this.obj.idcard == '' || this.obj.idCardImage == '' || this.obj.idCardImageReverse == '' || this.obj.idCardStartTime == '' || this.obj.district.district1 == '' || this.obj.idCardEndTime == '' || this.obj.district.districtDetail == '') {
                this.$message.error('带*号的选项不能为空');
            } else {
                this.api.update_user_info(this.obj).then(res => {
                    if (res.ok) {
                        this.$router.push('/user_info');
                        this.$message.success(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        }
    },
    created() {
        this.get_user_info();
    }
};
</script>

<style scoped>
/* ant-upload ant-upload-select ant-upload-select-picture-card */

.ant-upload-select {
    border-radius: 50% !important;
    float: left !important;
}

.save_but {
    width: 100px;
    height: 40px;
    border: 1px solid #2c9a34;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    margin-left: 130px;
    margin-top: 4%;
    cursor: pointer;
}

.ant-upload {
    width: 170px !important;
    height: 132px !important;
}

.chang_tel {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    float: left;
    margin-left: 10px;
    margin-top: 5px;
}

.left_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    width: 10%;
    text-align: right;
    float: left;
    margin-top: 5px;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    width: 80%;
    min-height: 990px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}

.ant-upload {
    width: 170px !important;
    height: 130px !important;
}
.tips {
    margin-left: 14%;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/user_info_edit.vue